// extracted by mini-css-extract-plugin
export default {"green":"styles_green__yStum","blank":"styles_blank__tgtpX","blue":"styles_blue__HBLYj","red":"styles_red__ZNykB"};